import React from "react"
import RyderLivescoringTournamentHeader from "@/components/RyderLivescoring/RyderLivescoringTournamentHeader"
import {
    RyderLivescoringTabs,
    TabsContent,
    TabsList,
    TabsTrigger
} from "@/components/RyderLivescoring/RyderLivescoringTabs"
import RyderLivescoringSession from "@/components/RyderLivescoring/RyderLivescoringSession"

const RyderLivescoringDefaultView = ({
    teams,
    isGroupingView,
    stateData,
    setActiveTab,
    sessions,
    activeTab,
    teamColors,
    customDesign
}) => {
    const isCm00Organizer = "CM00" === stateData.competition?.organiser

    if (teams.length < 2) {
        return (
            <div className={`ryderLivescoring flex flex-col w-full mx-auto px-2 py-2 overflow-x-hidden sm:h-screen sm:overflow-hidden
                md:h-screen md:overflow-hidden lg:flex-row lg:space-x-2 lg:h-screen nin9rs
            `}>
                <main className="flex-1 bg-slate-100 overflow-hidden rounded-lg p-2 shadow-md text-center pt-8">
                    {
                        !isGroupingView ? (
                            <h2 className="m-2 px-2 py-6 text-lg font-semibold text-gray-400">DEBE HABER 2 EQUIPOS PARA PODER VISUALIZAR LA
                                RYDER CUP</h2>
                        ) : (
                            <h2 className="m-2 px-2 py-6 text-lg font-semibold text-gray-400">AÚN NO HAN SIDO DEFINIDOS LOS EQUIPOS</h2>
                        )
                    }
                </main>
            </div>
        )
    }

    let asideStyles = 'mb-2 lg:mb-0 lg:w-1/4'
    let containerDivStyles = "ryderLivescoring flex flex-col w-full mx-auto px-2 py-2 overflow-x-hidden sm:h-screen sm:overflow-hidden md:h-screen md:overflow-hidden lg:flex-row lg:space-x-2 lg:h-screen"
    if (isGroupingView) {
        asideStyles = ''
        containerDivStyles = "ryderLivescoring flex flex-col w-full mx-auto px-2 py-2"
    }

    return (
        <div className={containerDivStyles + " nin9rs"} data-competition={stateData.competition.id}>
            <aside className={asideStyles}>
                <RyderLivescoringTournamentHeader
                    competition={stateData.competition}
                    teams={teams}
                    isGroupingView={isGroupingView}
                    customDesign={customDesign}
                />
            </aside>

            {
                !isGroupingView &&
                <div className="flex-1 flex flex-col overflow-hidden">
                    <main className="flex-1 bg-slate-100 overflow-hidden rounded-lg p-2 shadow-md">
                        {sessions.length > 1 ? (
                            <RyderLivescoringTabs defaultValue={activeTab} onValueChange={setActiveTab}>
                                <TabsList className="mb-4 grid grid-cols-2 gap-2">
                                    {sessions.map((s) => (
                                        <TabsTrigger
                                            key={s.id}
                                            value={s.id}
                                            className="text-xs sm:text-sm xl:text-xl 2xl:text-3xl"
                                        >
                                            {s.name}
                                        </TabsTrigger>
                                    ))}
                                </TabsList>

                                {sessions.map((s, idx) => (
                                    <TabsContent key={s.id} value={s.id}>
                                        <RyderLivescoringSession
                                            session={s}
                                            teamColors={teamColors}
                                            teams={teams}
                                            headerName={isCm00Organizer ? `Round ${idx + 1}` : null}
                                            hideModality={isCm00Organizer}
                                            customDesign={customDesign}
                                        />
                                    </TabsContent>
                                ))}
                            </RyderLivescoringTabs>
                        ) : (
                            sessions[0] ? (
                                <RyderLivescoringSession
                                    session={sessions[0]}
                                    teamColors={teamColors}
                                    teams={teams}
                                    showHeader={false}
                                    headerName={isCm00Organizer ? "Round 1" : null}
                                    hideModality={isCm00Organizer}
                                    customDesign={customDesign}
                                />
                            ) : (
                                <div className="text-center">
                                    <h2 className="m-2 px-2 py-6 text-lg font-semibold text-gray-400">NO HAY NINGÚN ENFRENTAMIENTO
                                        DEFINIDO AÚN</h2>
                                </div>
                            )
                        )}
                    </main>
                </div>
            }
        </div>
    )
}

export default RyderLivescoringDefaultView
